import { HelpCircle } from "lucide-react";
import { useTooltipGroup } from "./useTooltipGroup";
import { useRouteTooltipAvailability } from "./useRouteTooltipGroup";
import { runTour } from "./engine";
import { setTooltipPrefs } from "./prefs";
import "./tooltips.css";

/**
 * Floating "start the tour" button. Only rendered when the current route
 * resolves to an enabled group that actually has walkthrough steps. Starting
 * the tour manually never changes the user's global preference.
 */
export function TourLauncher({ groupKey }: { groupKey: string }) {
  const { data } = useTooltipGroup(groupKey);
  const { tourAvailable } = useRouteTooltipAvailability();

  if (!tourAvailable || !data) return null;

  return (
    <button
      type="button"
      className="podgo-tour-launcher"
      aria-label={`Start page tour: ${data.group.name}`}
      title="Start page tour"
      onClick={() =>
        runTour(data.tips, {
          // Manual replays still mark the auto-tour as seen for this group.
          onFinish: () => setTooltipPrefs(groupKey, { tour: false }),
        })
      }
    >
      <HelpCircle className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}

export default TourLauncher;
